import { createUseStyles } from 'react-jss';
import { color, fontSize, radius, spacing } from '@blink/components';

export const useTeamStyle = createUseStyles({
    content: {
        display: 'flex',
        justifyContent: 'center',
        gap: spacing['07'],
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderRadius: radius.xs,
        marginBottom: spacing['10'],
    },
    heading: {
        display: 'flex',
        padding: `${spacing['06']} 0px`,
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing['02'],
    },
    titleText: {
        color: color.content.primary,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '40px',
        letterSpacing: '-0.64px',
    },
    top: {
        display: 'flex',
        padding: `${spacing['08']} 10% 0`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    main: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: spacing['06'],
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
    },
    description: {
        color: color.content.secondary,
    },
    btn: {
        display: 'flex',
        alignItems: 'center',
        padding: `${spacing['03']} ${spacing['04']}`,
        gap: 4,
        fontSize: fontSize.md,
        '& svg path': {
            fill: color.background.primary,
        },
    },
    note: {
        fontSize: 16,
        lineHeight: '20px',
        letterSpacing: '-0.48px',
        color: color.content.secondary,
        fontWeight: 400,
        marginTop: spacing['03'],
    },
});
